module.exports = __webpack_public_path__ + "static/media/contact-modal-image.3d831b04.png";